import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { useApi } from "../lib/api";
import { useTenant } from "../lib/tenant";

type Achievement = {
  id: string;
  title: string;
  unlocked: boolean;
  detail: string;
};

type AchievementResponse = {
  tenant_id: string;
  generated_at: string;
  unlocked: number;
  total: number;
  items: Achievement[];
};

export default function AchievementsPage() {
  const api = useApi();
  const { effectiveTenantId } = useTenant();
  const achievements = useQuery({
    queryKey: ["achievements", effectiveTenantId],
    queryFn: () => api.get<AchievementResponse>("/achievements"),
    refetchInterval: 20_000,
  });
  const pct = achievements.data ? Math.round((achievements.data.unlocked / achievements.data.total) * 100) : 0;

  return (
    <section className="flow-page achievements-page">
      <header className="flow-hero">
        <div>
          <p className="hero-eyebrow">Achievements</p>
          <h1>Produktfortschritt sichtbar machen, ohne echte Umsetzung zu erfinden.</h1>
          <p className="hero-sub">
            Achievements werden aus Tenant-Events, Quellen, Quality Reports und Agent-Runs abgeleitet. Keine kosmetischen Badges ohne Evidence.
          </p>
        </div>
        <div className="flow-score">
          <span>Fortschritt</span>
          <strong>{pct}%</strong>
          <small>{achievements.data?.unlocked ?? 0} / {achievements.data?.total ?? 0}</small>
        </div>
      </header>

      {achievements.isLoading && <p className="muted">Lade Achievements...</p>}
      {achievements.error && <p className="error">Achievements nicht verfügbar.</p>}

      <div className="achievement-grid">
        {(achievements.data?.items ?? []).map((item) => (
          <article key={item.id} className={`achievement-card ${item.unlocked ? "unlocked" : "locked"}`}>
            <div className="achievement-mark">{item.unlocked ? "✓" : "·"}</div>
            <div>
              <h2>{item.title}</h2>
              <p className="muted small">{item.detail}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="flow-actions">
        <Link to="/app/sources" className="btn primary">Naechstes Gate abschließen</Link>
        <Link to="/app/agents" className="btn ghost">Agent Runs prüfen</Link>
      </div>
    </section>
  );
}
